import type { ContainerColor, CrossSize, MainColor, Radii } from './types';

export const RADII_VARIANTS: Record<Radii, string> = {
	Inherit: 'rounded-[inherit]',
	'0': 'rounded-r0',
	'300': 'rounded-r300',
	'400': 'rounded-r400',
	'500': 'rounded-r500',
	Pill: 'rounded-pill'
};

export const CROSS_SIZE_VARIANTS: Record<CrossSize, string> = {
	Inherit: 'size-x-inherit',
	'50': 'size-x50',
	'100': 'size-x100',
	'200': 'size-x200',
	'300': 'size-x300',
	'400': 'size-x400',
	'500': 'size-x500',
	'600': 'size-x600'
};

export const MAIN_COLOR_VARIANTS: Record<MainColor, string> = {
	Primary: 'variant-primary',
	Secondary: 'variant-secondary',
	Success: 'variant-success',
	Warning: 'variant-warning',
	Critical: 'variant-critical'
};

export const CONTAINER_COLOR_VARIANTS: Record<ContainerColor, string> = {
	Background: 'variant-background',
	Surface: 'variant-surface',
	SurfaceVariant: 'variant-surface-variant',
	...MAIN_COLOR_VARIANTS
};
